import {getLocalizationBasedOnLang} from '../../../data/models/User/UserInfo';

const english = {
  badge: 'tapybl tour',
  imagePlaceholder: 'image / GIF',
  imageRecommendation: '16:9 recommended',
  skip: 'Skip',
  back: 'Back',
  next: 'Next',
  done: 'Done',
  closeAriaLabel: 'Close tour',
};

const welsh = {
  badge: 'TAITH CYNNYRCH',
  imagePlaceholder: 'delwedd / GIF',
  imageRecommendation: '16:9 yn argymell',
  skip: 'Hepgor',
  back: 'Yn ôl',
  next: 'Nesaf',
  done: 'Gorffen',
  closeAriaLabel: 'Cau y daith',
};

export const tourTooltipText = getLocalizationBasedOnLang(english, welsh);
